import React from 'react';
import { Autocomplete, TextField, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';

const FormSelect = ({
  label,
  value,
  onChange,
  options,
  placeholder = "Select an option",
  fullWidth = true,
  size = "medium",
  className = "bg-white",
  searchable = true,
  name,
  required = false,
  error = false,
  errorMessage = '',
  disabled = false,
  loading = false,
  onOpen,
}) => {
  const selectedOption = options.find(option => option.value === value) || null;

  const handleChange = (event, newValue) => {
    const syntheticEvent = {
      target: {
        value: newValue ? newValue.value : ''
      }
    };
    onChange(syntheticEvent); // Send the value back to parent
  };

  if (!searchable) {
    return (
      <FormControl fullWidth={fullWidth} size={size} error={error} disabled={disabled}>
        <InputLabel>{label}{required && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}</InputLabel>
        <Select
          name={name}
          value={value}
          label={label}
          onChange={(e) => onChange(e)} // Directly using parent's onChange
          className={className}
          error={error}
          disabled={disabled || loading}
          onOpen={onOpen}
        >
          {placeholder && <MenuItem value="">{placeholder}</MenuItem>}
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {error && errorMessage && (
          <div style={{ color: '#d32f2f', fontSize: '0.75rem', marginTop: '4px', marginLeft: '14px' }}>
            {errorMessage}
          </div>
        )}
      </FormControl>
    );
  }

  return (
    <Autocomplete
      fullWidth={fullWidth}
      size={size}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      disabled={disabled}
      loading={loading}
      onOpen={onOpen}
      getOptionLabel={(option) => option.label || ''}
      isOptionEqualToValue={(option, value) => option.value === value?.value}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label + (required ? ' *' : '')}
          placeholder={placeholder}
          className={className}
          error={error}
          helperText={error ? errorMessage : ''}
          sx={{
            '& .MuiOutlinedInput-root': { backgroundColor: 'white' }
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>{option.label}</li>
      )}
      filterOptions={(options, { inputValue }) => options.filter(option => 
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      )}
      noOptionsText="No options found"
    />
  );
};

export default FormSelect;
